export { default } from 'shared/components/dayNight'
